/* eslint-disable no-console */
import { Injectable } from "../../dependencies/injectable";
import { DataSource, DataSourceUID, DefaultDataSourceContext } from "../../forms/dataSource";
import { DATA_SOURCE_SERVICE, DataSourceService } from "../dataSource.service";

export type DataSourceMap = Map<DataSourceUID, DataSource<unknown, unknown, unknown>>;

/**
 * DataSource service 
 */
@Injectable(DATA_SOURCE_SERVICE)
export class DefaultDataSourceService implements DataSourceService {

    protected _dataSource: DataSourceMap = new Map<DataSourceUID, DataSource<unknown, unknown, unknown>>();

    /**
     * Get a dataSource from DataSourceUID
     * @param uid DataSourceUID to get from
     */
    getDataSource<T = unknown, V = unknown, DataSourceContext = DefaultDataSourceContext<unknown>>(uid: DataSourceUID): DataSource<T, V, DataSourceContext> | undefined {
        const dataSource = this._dataSource.get(uid);
        return dataSource as DataSource<T, V, DataSourceContext> | undefined;
    }

    /**
     * Add a dataSource with DataSourceUID
     * @param uid DataSourceUID to add
     * @param dataSource DataSource to map to dataSourceUID
     */
    addDataSource<T, V, DataSourceContext = DefaultDataSourceContext<T>>(uid: DataSourceUID, dataSource: DataSource<T, V, DataSourceContext>): void {
        this._dataSource.set(uid, dataSource);
    }

}
